import ConnectedUsersList from '../../components/UpdateComponents/ConnectedUsersList'

const ConnectedUsers = ({ isConnectedUsersOpen, handleCloseConnectedUsers }) => {
  return <ConnectedUsersList isOpen={isConnectedUsersOpen} onClose={handleCloseConnectedUsers} />
}
export default ConnectedUsers
